import React from 'react'
import "../App.css"
import { useSelector } from 'react-redux'
const Dashboard = () => {
    const userdata=useSelector(state=>state.login.data)
  return (
    <div>
<center style={{color:"red",fontSize:"24px",fontWeight:"bold"}}>Dashboard</center>

<table border={1}>
<thead>
    <th>S.NO</th>
    <th>Name</th>
    <th>Char count</th>
    <th>CPM</th>
    <th>Accuracy rate</th>
</thead>
<tbody>
{userdata.map((el,i)=>{
   
    return <tr>
        <td>{i+1}</td>
        <td>{el.name}</td>
        <td>{el.count}</td>
        <td>{el.cpm}</td>
        <td>{el.accuracy}</td>
    </tr>
})}

</tbody>

</table>
    </div>
  )
}

export default Dashboard